import { render, staticRenderFns } from "./ChaptersSkeletonLoader.vue?vue&type=template&id=e36a869e&scoped=true&"
import script from "./ChaptersSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./ChaptersSkeletonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36a869e",
  null
  
)

export default component.exports